var menuHeights = {
  max: "100%",
  large: "344px"
};
var menuWidths = {
  max: "720px",
  large: "360px",
  medium: "260px",
  small: "180px"
};

export { menuHeights, menuWidths };
//# sourceMappingURL=dropdown-menu-constants.js.map
